import { T } from '@tolgee/react';
import styled from 'styled-components';

import BrainSvg from '../../../../assets/icons/BrainSvg';
import { DynamicLessonState } from '../../../../hooks/useCreateLessonState';
import { IconWrapper } from '../../../_atoms/IconWrapper';

type AgentState = DynamicLessonState['agent']['state'];

export function AgentStateBadge({ agentState }: { agentState: AgentState }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '20px auto',
        gap: 5,
        alignItems: 'center',
      }}
    >
      <IconWrapper height="16px" width="16px">
        <BrainSvg />
      </IconWrapper>
      <ThinkingMessage>
        {agentState === 'thinking' && <T keyName="thinking" defaultValue="Thinking" />}
        {agentState === 'generating' && (
          <T keyName="generating" defaultValue="Generating" />
        )}
        {agentState != null &&
          !['generating', 'thinking'].includes(
            agentState as Exclude<AgentState, null>,
          ) && <T keyName={agentState} defaultValue={agentState} />}
      </ThinkingMessage>
    </div>
  );
}

const ThinkingMessage = styled.p`
  text-transform: capitalize;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  gap: 8px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  background: linear-gradient(
    to left,
    #b9b9b9 20%,
    #393939 30%,
    #393939 70%,
    #b9b9b9 80%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  background-size: 200% auto;
  animation: textShine 2.5s linear infinite;
  @keyframes textShine {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: -100% 50%;
    }
  }
`;
